import React from 'react';
import './About.css';

import { Button, Heading} from '../../../components'; // Import necessary components
import { about } from '../../../constants';

import { FaShieldAlt } from 'react-icons/fa';



const About = () => {

  const { sub, heading, description, points, image, button } = about;

  return (
    <section className="about">

      {/* About Image */}
      <div className="image">
        <div className="sub-image one">
          <img src={image.src1} alt={image.alt1} />
        </div>
        <div className="sub-image two">
          <img src={image.src2} alt={image.alt2} />
          <div className="experience">
            <div className='shield-icon'><FaShieldAlt /></div>
            <div className="text">
              <span>{image.experience.years}</span><br /> {image.experience.title}
            </div> 
          </div>
        </div>
      </div>

      {/* Introduction Content */}
      <div className="content">

        {/* Section Heading */}
        <Heading title={heading} subTitle={sub} sideHeading />

        {/* Description */}
        <p>{description}</p>

        {/* Key Features */}
        <div className="about-section-points">
          {points.map((point, index) => (
            <div className="item" key={index}>
              <div className="icon">{point.icon}</div>
              <div className='text'>
                <h5>{point.title}</h5>
                <p>{point.content}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Button Component: Links to a specific page or action */}
        <Button link={button.link} title={button.text} />

      </div>
    </section>
  );
};

export default About;